import { Component, OnInit } from '@angular/core';
import {  NgWizardConfig, NgWizardService, StepChangedArgs, StepValidationArgs, THEME } from 'ng-wizard';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';

@Component({
  selector: 'app-reward-setup',
  templateUrl: './reward-setup.component.html',
  styleUrls: ['./reward-setup.component.scss']
})
export class RewardSetupComponent implements OnInit {

  config: NgWizardConfig = {
    selected: 0,
    theme: THEME.arrows
  };
  createRewardFlag:boolean = true
  whitelistUserFlag:boolean = true
  rewardCreatedId:any
  constructor(
      private apiService : ApiService,
      private apiConfig : ApiConfiguration,
      private ngWixardService : NgWizardService
  ) { 

  }

  ngOnInit() {
    let configDetails = JSON.parse(localStorage.getItem('configFlags'))
    console.log(configDetails)
    this.createRewardFlag = configDetails.createReward
    this.whitelistUserFlag = configDetails.whitelistUser
    if(configDetails.whitelistUser == true){
      this.gotoWhitelistUsers(true) 
    }
  }

  gotoWhitelistUsers(e){
    console.log(e)
    this.whitelistUserFlag = e
    setTimeout(()=>{
      this.ngWixardService.next()
    },200)
  }

  getRewardCreatedID(event){
    console.log('created Reward ID',event)
    this.rewardCreatedId = event
  }

}
